<script>
import { Sprite, Container } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene10',
  mixins: [ SceneMixin ],
  beforeDestroy() {
    console.log('beforeDestroy');
    _.each(this.$sprites, (sp, index)=>{
      if(this.$els[index]) this.$els[index]['container'].removeChild(sp)
    })
    this.$container.removeChild(this.$scene)
  },

  created() {

    const sprites = {}
    this.$sprites = sprites

    this.$scene = new Container 
    this.$scene.interactiveChildren = false
    
    this.$container.addChild(this.$scene)
    this.$parent.$scene10 = this.$scene

    const container = new Container()
          container.alpha = 0
    this.setCenterContainer(container)   
    this.$scene.addChild(container)

    const sub1 = new TimelineMax()
    const sub2 = new TimelineMax()
    const sub3 = new TimelineMax()

    // ******************************************************** //
    // ******************************************************** //

    const els = {

      'border': { container: container, alpha: 1, scale: this.$root.$scale*1.08, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, },
      'front': { container: container, alpha: 0, scale: this.$root.$scale*1.6, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, y: -50 },
      'top': { container: container, alpha: 0,  position: { x: 676, y: 665, width: 191, height: 217 }, scale: this.$root.$scale*2.5, y: -200 },
      'top_el1': { container: container, alpha: 0,  position: { x: 676, y: 665, width: 191, height: 217 }, scale: this.$root.$scale*2.5, y: -200 },
      'left': { container: container, alpha: 0,  position: { x: 532, y: 938, width: 187, height: 752 }, scale: this.$root.$scale*2.5, x: -250, y: -200 },
      'left_el1': { container: container, alpha: 0,  position: { x: 532, y: 938, width: 187, height: 752 }, scale: this.$root.$scale*2.5, x: -250, y: -200 },
      'left_el2': { container: container, alpha: 0,  position: { x: 532, y: 938, width: 187, height: 752 }, scale: this.$root.$scale*2.5, x: -250, y: -200 },
      'left_el3': { container: container, alpha: 0,  position: { x: 532, y: 938, width: 187, height: 752 }, scale: this.$root.$scale*2.5, x: -250, y: -200 },
      'left_el4': { container: container, alpha: 0,  position: { x: 532, y: 938, width: 187, height: 752 }, scale: this.$root.$scale*2.5, x: -250, y: -200 },
      'left_el5': { container: container, alpha: 0,  position: { x: 532, y: 938, width: 187, height: 752 }, scale: this.$root.$scale*2.5, x: -250, y: -200 },
      'left_el6': { container: container, alpha: 0,  position: { x: 532, y: 938, width: 187, height: 752 }, scale: this.$root.$scale*2.5, x: -250, y: -200 },
      'left_el7': { container: container, alpha: 0,  position: { x: 532, y: 938, width: 187, height: 752 }, scale: this.$root.$scale*2.5, x: -250, y: -200 },
      'right': { container: container, alpha: 0,  position: { x: 817, y: 938, width: 188, height: 752 }, scale: this.$root.$scale*2.5, x: 250, y: -200 },
      'right_el1': { container: container, alpha: 0,  position: { x: 817, y: 938, width: 188, height: 752 }, scale: this.$root.$scale*2.5, x: 250, y: -200 },
      'right_el2': { container: container, alpha: 0,  position: { x: 817, y: 938, width: 188, height: 752 }, scale: this.$root.$scale*2.5, x: 250, y: -200 },
      'right_el3': { container: container, alpha: 0,  position: { x: 817, y: 938, width: 188, height: 752 }, scale: this.$root.$scale*2.5, x: 250, y: -200 },
      'right_el4': { container: container, alpha: 0,  position: { x: 817, y: 938, width: 188, height: 752 }, scale: this.$root.$scale*2.5, x: 250, y: -200 },
      'right_el5': { container: container, alpha: 0,  position: { x: 817, y: 938, width: 188, height: 752 }, scale: this.$root.$scale*2.5, x: 250, y: -200 },
      'right_el6': { container: container, alpha: 0,  position: { x: 817, y: 938, width: 188, height: 752 }, scale: this.$root.$scale*2.5, x: 250, y: -200 },
      'right_el7': { container: container, alpha: 0,  position: { x: 817, y: 938, width: 188, height: 752 }, scale: this.$root.$scale*2.5, x: 250, y: -200 },
      'center': { container: container, alpha: 0,  position: { x: 727, y: 916, width: 83, height: 106 }, scale: this.$root.$scale*2, y: 25 },
      'grey': { container: container, alpha: 0, scale: this.$root.$scale*2.18, position: { x: 0, y: 0, width: 1536, height: 2160 }, anchor: { x: 0.5, y: 0.5 }, x: 1, y: 16 },    
    }

    _.each(els, (el, name)=>{
      const sprite = new Sprite.from(this.$resources[name].texture) 
            sprite.scale.set(this.$root.$scale)
            sprite.x -= this.$canvas_width/2
            sprite.y -= this.$canvas_height/2
            sprite.alpha = el.alpha
      el.container.addChild(sprite)
      sprites[name] = sprite
      this.applySettings(sprite, el)
    })

    this.$els = els

    // ******************************************************** //
    // ******************************************************** //

    // const alphaFilter = new PIXI.filters.AlphaFilter(0.0)
    // container.filters = [ alphaFilter ]
    
    const coef = .15

    const tempo = 5*coef
    const batch_left = _.shuffle([sprites['left_el1'], sprites['left_el2'], sprites['left_el3'], sprites['left_el4'], sprites['left_el5'], sprites['left_el6'], sprites['left_el7']])
    const batch_right = _.shuffle([sprites['right_el1'], sprites['right_el2'], sprites['right_el3'], sprites['right_el4'], sprites['right_el5'], sprites['right_el6'], sprites['right_el7']])

    sub1
      // .to(alphaFilter, 1, { alpha: 1, ease: Linear.easeNone, onComplete: ()=>{ container.filters = null } })
      .to(container, 1, { alpha: 1, ease: Linear.easeNone })
      .add([
        TweenMax.to(sprites['border'], 5*coef, { pixi:{ alpha: 1, scale: this.$root.$scale*1 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['top'], 5*coef, { pixi:{ alpha: 1, y: '+=200', scale: this.$root.$scale*1 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['left'], 15*coef, { pixi:{ alpha: 1, x: '+=250', y: '+=200', scale: this.$root.$scale*1 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['right'], 10*coef, { pixi:{ alpha: 1, x: '-=250', y: '+=200', scale: this.$root.$scale*1 }, ease: Linear.easeNone }),
      ])

      .add([
        TweenMax.to(sprites['top_el1'], 5*coef, { pixi:{ alpha: 1, y: '+=200', scale: this.$root.$scale*1 }, ease: Linear.easeNone }),
        TweenMax.staggerTo(batch_left, 5*coef, { pixi:{ alpha: 1, x: '+=250', y: '+=200', scale: this.$root.$scale*1, delay: 5*coef }, ease: Linear.easeNone }, 2*coef),
        TweenMax.staggerTo(batch_right, 5*coef, { pixi:{ alpha: 1, x: '-=250', y: '+=200', scale: this.$root.$scale*1 }, ease: Linear.easeNone }, 2*coef),
        TweenMax.to(sprites['center'], 5*coef, { pixi:{ alpha: 1, y: '-=25', scale: this.$root.$scale*1 }, ease: Linear.easeNone }),
      ])

      .add([

        TweenMax.to(sprites['center'], 5*coef, { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['top'], 5*coef, { pixi:{ alpha: 0, }, ease: Linear.easeNone }),
        TweenMax.to(sprites['left'], 5*coef, { pixi:{ alpha: 0, }, ease: Linear.easeNone }),
        TweenMax.to(sprites['right'], 5*coef, { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['grey'], 5*coef, { pixi:{ alpha: 1 }, ease: Linear.easeNone })
      ])

    sub2
      .set({}, {delay: sub1.duration()*0.10 })
      .to(sprites['front'], tempo*2, { pixi:{ alpha: 1, scale: this.$root.$scale*1, y: '+=50' }, ease: Linear.easeNone })

    this.$tl.add([ sub1, sub2 ])

  },
  mounted() {

    // console.log('Scene10');
   
  }
}
</script>























